/* eslint-disable max-lines, complexity */
import {
  ADD_ACCOMMODATION_AND_EXTRAS_TO_BASKET,
  ADD_ACCOMMODATION_AND_EXTRAS_TO_BASKET_SUCCESS,
  ADD_ACCOMMODATION_EXTRAS_TO_BASKET,
  ADD_ACCOMMODATION_EXTRAS_TO_BASKET_SUCCESS,
  ADD_ACCOMMODATION_TO_BASKET,
  ADD_ACCOMMODATION_TO_BASKET_SUCCESS,
  ADD_EXTRAS_TO_BASKET,
  ADD_NAME_CHANGE_TO_BASKET,
  ADD_TICKETS_TO_BASKET,
  ADD_TO_BASKET_FAILED,
  ADD_TRANSPORT_TO_BASKET,
  CHECK_BASKET,
  CHECK_BASKET_COMPLETE,
  CREATE_BASKET_SUCCESS,
  GET_BASKET,
  GET_BASKET_SUCCESS,
  PROCESSING_RESPONSE,
  REMOVE_EXTRA,
  REMOVE_ITEMS,
  RESET_BASKET_SUCCESS,
} from './types';

const initialState = {};

const basketReducer = (state = initialState, action) => {
  switch (action.type) {
    case CHECK_BASKET: {
      return { ...state, processing: true };
    }
    case CHECK_BASKET_COMPLETE: {
      return { ...state, processing: false };
    }
    case CREATE_BASKET_SUCCESS:
      return {
        ...state,
        [action.payload.bookingRef]: action.payload.basket,
      };
    case GET_BASKET_SUCCESS:
      return {
        ...state,
        [action.payload.bookingRef]: action.payload.basket,
        processing: false,
      };
    case ADD_TO_BASKET_FAILED:
      return {
        ...state,
        processing: false,
      };
    case ADD_ACCOMMODATION_TO_BASKET:
      return {
        ...state,
        processing: true,
      };
    case ADD_ACCOMMODATION_TO_BASKET_SUCCESS:
      return {
        ...state,
        basketAccommodationsAdded: action.payload.accommodations,
      };

    case ADD_ACCOMMODATION_AND_EXTRAS_TO_BASKET:
      return {
        ...state,
        processing: true,
      };

    case ADD_ACCOMMODATION_AND_EXTRAS_TO_BASKET_SUCCESS:
      return {
        ...state,
        [action.payload.bookingRef]: action.payload.basket,
        basketAccommodationsAdded: [],
        processing: false,
      };

    case ADD_ACCOMMODATION_EXTRAS_TO_BASKET:
      return {
        ...state,
        processing: true,
      };

    case ADD_ACCOMMODATION_EXTRAS_TO_BASKET_SUCCESS:
      return {
        ...state,
        processing: false,
        basketAccommodationsAdded: [],
      };
    case ADD_EXTRAS_TO_BASKET:
      return {
        ...state,
        processing: true,
      };
    case ADD_TRANSPORT_TO_BASKET:
      return {
        ...state,
        processing: true,
      };
    case ADD_NAME_CHANGE_TO_BASKET:
      return {
        ...state,
        processing: true,
      };
    case ADD_TICKETS_TO_BASKET:
      return {
        ...state,
        processing: true,
      };
    case GET_BASKET:
      return {
        ...state,
        processing: true,
      };
    case REMOVE_EXTRA:
      return {
        ...state,
        processing: true,
      };
    case REMOVE_ITEMS:
      return {
        ...state,
        processing: true,
      };
    case RESET_BASKET_SUCCESS:
      return initialState;
    case PROCESSING_RESPONSE:
      return {
        ...state,
        awaitingResponse: action?.payload.processing,
      };
    default:
      return state;
  }
};

export default basketReducer;
